export type BlogPostPath =
  | "/blog/questions-to-ask-before-paying-a-limo-deposit"
  | "/blog/corporate-holiday-party-transportation-planning-guide";

export type BlogPostMeta = {
  slug: string;
  path: BlogPostPath;
  title: string;
  description: string;
  date: string; // ISO yyyy-mm-dd
  excerpt: string;
};

export const BLOG_AUTHOR = "Maria Priestly";

export const BLOG_POSTS: BlogPostMeta[] = [
  {
    slug: "questions-to-ask-before-paying-a-limo-deposit",
    path: "/blog/questions-to-ask-before-paying-a-limo-deposit",
    title: "9 Questions to Ask Before You Pay a Limo Deposit in Atlanta",
    description:
      "Before you pay any Atlanta limo deposit, ask these nine questions: who owns the vehicle, will a subcontractor show up, is the chauffeur fingerprinted, and more.",
    date: "2026-10-04",
    excerpt:
      "Who owns the vehicle? Will a subcontractor show up? Nine questions that tell you whether the limo you book is the one that arrives.",
  },
  {
    slug: "corporate-holiday-party-transportation-planning-guide",
    path: "/blog/corporate-holiday-party-transportation-planning-guide",
    title: "Holiday Party Transportation in Atlanta: A Planning Guide for Executive Assistants",
    description:
      "A practical timeline and checklist for executive assistants planning Atlanta holiday party transportation, from eight weeks out to the night of the party.",
    date: "2026-10-04",
    excerpt:
      "A week-by-week timeline, a checklist of what to send your transportation company, and how to choose between group loops and executive cars.",
  },
];

export function formatPostDate(iso: string) {
  return new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    timeZone: "UTC",
  });
}

export function getPost(slug: string) {
  const p = BLOG_POSTS.find((x) => x.slug === slug);
  if (!p) throw new Error(`Unknown post ${slug}`);
  return p;
}
